import type { FeatureFlagsPluginOptions } from '@atlaskit/editor-plugin-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

interface Props {
	options: never;
}

export function featureFlagsPluginOptions({}: Props): FeatureFlagsPluginOptions {
	/**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */
	return {
		lpLinkPicker: true,
		tableDragAndDrop: editorExperiment('platform_editor_tables_drag_and_drop', true),
		tableWithFixedColumnWidthsOption: true,

		tableSelector: editorExperiment('platform_editor_tables_table_selector', true),
		macroInteractionUpdates: true,
		moreElementsInQuickInsertView: true,

		catchAllTracking: false,
		showAvatarGroupAsPlugin: false,
		errorBoundaryDocStructure: false,
		synchronyErrorDocStructure: false,
		enableViewUpdateSubscription: false,
		collabAvatarScroll: false,
		twoLineEditorToolbar: false,
		disableSpellcheckByBrowser: undefined,
	};
}
